const tour = {
  id: 'claimRegister-tour',
  steps: [
    {
      title: 'Policy Search',
      content: 'You can do a quick search to get a Policy',
      target: 'getPoliciesBtn',
      placement: 'right'
    },
    {
      title: 'Overview',
      content: 'Some Important information will display here',
      target: 'OverviewBtn',
      placement: 'left'
    },
    {
      title: 'Proceed Next',
      content: 'After finish field requirement, then proceed to next srceen',
      target: 'createClaimBtn',
      placement: 'right'
    }
  ]
}

export default tour
